import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stepper,
  Step,
  StepLabel,
  Paper
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Person as PersonIcon,
  Work as WorkIcon,
  School as SchoolIcon,
  LocationOn as LocationIcon,
  Save as SaveIcon,
  AccountBalance as BankIcon,
  Security as SecurityIcon,
  DirectionsCar as CarIcon
} from '@mui/icons-material';
import Swal from 'sweetalert2';

// Import static data
import { employeesData } from '../../Data/Kontak/Employee';

const AddEmployeeStatic = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  
  const [formData, setFormData] = useState({
    // Data Pribadi
    personalData: {
      employee_id: '',
      employee_code: '',
      gender: '',
      employee_name: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      birth_date: '',
      modified_by: '',
      active_status: 1,
      employment_status: '',
      remarks: '',
      seniority_date: '',
      birth_place: '',
      mother_maiden_name: '',
      marital_status: '',
      marital_date: '',
      religion: '',
      photo: ''
    },
    // Info Pekerjaan
    workInfo: {
      business_unit: '',
      branch_id: '',
      branch_name: '',
      region: '',
      department: '',
      position: '',
      organization: '',
      composition: '',
      position_group: '',
      grade: '',
      employee_group: '',
      education: '',
      education_group: '',
      university: ''
    },
    // Alamat
    address: {
      street: '',
      subdistrict: '',
      rt: '',
      rw: '',
      postal_code: '',
      city: '',
      county: '',
      province: '',
      country: '',
      location_id: ''
    },
    // Benefit
    benefit: {
      lspsi: 0,
      lkoperasi: 0,
      lsbsi: 0,
      lspn: 0,
      lbpjs_ketenagakerjaan_date: '',
      lbpjs_ketenagakerjaan_no: '',
      laviva_register_date: '',
      laviva_number: '',
      lbpjs_kesehatan_date: '',
      lbpjs_kesehatan_no: '',
      lbumida_date: '',
      lbumida_no: '',
      lbpjs_pensiun_date: '',
      lbpjs_pensiun_no: '',
      company_insurance_no: ''
    },
    // Kontak
    contact: {
      mobile_phone: '',
      alt_mobile_phone: '',
      previous_email: '',
      corporate_email: ''
    },
    // Tax
    tax: {
      tax_category: '',
      tax_id: '',
      payroll_seniority: '',
      salary_scale_date: '',
      year_tax_point_15: '',
      year_tax_point_20: ''
    },
    // Others
    others: {
      office_type: '',
      pakta_integritas_2025: 0,
      rahasia_perusahaan_2025: 0,
      update_data_karyawan_2025: '',
      penjamin: '',
      update_penjamin_2025: '',
      scan_biodata: 0,
      screening_sdm: 0,
      vehicle_and_facility: 0,
      toll_fee: '',
      distance_km: ''
    }
  });

  const steps = [
    'Data Pribadi',
    'Info Pekerjaan', 
    'Alamat',
    'Benefit & Kontak',
    'Tax & Others'
  ];

  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleNext = () => {
    setActiveStep(prev => prev + 1);
  };

  const handleBack = () => {
    setActiveStep(prev => prev - 1);
  };

  const handleSave = () => {
    // Validation
    if (!formData.personalData.employee_name || !formData.personalData.employee_code) {
      Swal.fire({
        title: '⚠️ Data Tidak Lengkap!',
        html: `
          <div class="text-center">
            <div class="bg-yellow-50 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <svg class="w-10 h-10 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
            </div>
            <p class="text-gray-600 mb-2">Mohon lengkapi data wajib:</p>
            <ul class="text-sm text-gray-500 text-left">
              ${!formData.personalData.employee_name ? '<li>• Nama Karyawan</li>' : ''}
              ${!formData.personalData.employee_code ? '<li>• Kode Karyawan</li>' : ''}
            </ul>
          </div>
        `,
        confirmButtonText: '📝 Oke, Saya Perbaiki',
        customClass: {
          popup: 'animate-bounce-in',
          confirmButton: 'bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200'
        },
        buttonsStyling: false
      });
      return;
    }

    // Success message
    Swal.fire({
      title: '🎉 Berhasil Ditambahkan!',
      html: `
        <div class="text-center">
          <div class="bg-green-50 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <svg class="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <p class="text-gray-600 mb-2">Karyawan <strong>${formData.personalData.employee_name}</strong> berhasil ditambahkan!</p>
          <p class="text-sm text-gray-500">Anda akan diarahkan ke halaman daftar karyawan.</p>
        </div>
      `,
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
      customClass: {
        popup: 'animate-bounce-in'
      }
    }).then(() => {
      navigate('/kontak/employee');
    });
  };

  const renderPersonalDataForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }} className="animate-slide-up">
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: 'primary.main' }}><PersonIcon /></Avatar>}
        title="Data Pribadi"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Employee ID"
              type="number"
              value={formData.personalData.employee_id}
              onChange={(e) => handleInputChange('personalData', 'employee_id', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Employee Code"
              value={formData.personalData.employee_code}
              onChange={(e) => handleInputChange('personalData', 'employee_code', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nama Karyawan"
              value={formData.personalData.employee_name}
              onChange={(e) => handleInputChange('personalData', 'employee_name', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Jenis Kelamin</InputLabel>
              <Select
                value={formData.personalData.gender}
                onChange={(e) => handleInputChange('personalData', 'gender', e.target.value)}
              >
                <MenuItem value="L">Laki-laki</MenuItem>
                <MenuItem value="P">Perempuan</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Nama Depan"
              value={formData.personalData.first_name}
              onChange={(e) => handleInputChange('personalData', 'first_name', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Nama Tengah"
              value={formData.personalData.middle_name}
              onChange={(e) => handleInputChange('personalData', 'middle_name', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Nama Belakang"
              value={formData.personalData.last_name}
              onChange={(e) => handleInputChange('personalData', 'last_name', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tanggal Lahir"
              type="date"
              value={formData.personalData.birth_date}
              onChange={(e) => handleInputChange('personalData', 'birth_date', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tempat Lahir"
              value={formData.personalData.birth_place}
              onChange={(e) => handleInputChange('personalData', 'birth_place', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Status Kepegawaian</InputLabel>
              <Select
                value={formData.personalData.employment_status}
                onChange={(e) => handleInputChange('personalData', 'employment_status', e.target.value)}
              >
                <MenuItem value="Permanent">Permanent</MenuItem>
                <MenuItem value="Contract">Contract</MenuItem>
                <MenuItem value="Intern">Intern</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Agama"
              value={formData.personalData.religion}
              onChange={(e) => handleInputChange('personalData', 'religion', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Status Pernikahan"
              value={formData.personalData.marital_status}
              onChange={(e) => handleInputChange('personalData', 'marital_status', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nama Gadis Ibu"
              value={formData.personalData.mother_maiden_name}
              onChange={(e) => handleInputChange('personalData', 'mother_maiden_name', e.target.value)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderWorkInfoForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }} className="animate-slide-up">
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: 'success.main' }}><WorkIcon /></Avatar>}
        title="Info Pekerjaan"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Unit Bisnis"
              value={formData.workInfo.business_unit}
              onChange={(e) => handleInputChange('workInfo', 'business_unit', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Branch ID"
              value={formData.workInfo.branch_id}
              onChange={(e) => handleInputChange('workInfo', 'branch_id', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nama Cabang"
              value={formData.workInfo.branch_name}
              onChange={(e) => handleInputChange('workInfo', 'branch_name', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Departemen"
              value={formData.workInfo.department}
              onChange={(e) => handleInputChange('workInfo', 'department', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Posisi"
              value={formData.workInfo.position}
              onChange={(e) => handleInputChange('workInfo', 'position', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Organisasi"
              value={formData.workInfo.organization}
              onChange={(e) => handleInputChange('workInfo', 'organization', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Grade"
              value={formData.workInfo.grade}
              onChange={(e) => handleInputChange('workInfo', 'grade', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Grup Karyawan"
              value={formData.workInfo.employee_group}
              onChange={(e) => handleInputChange('workInfo', 'employee_group', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Pendidikan"
              value={formData.workInfo.education}
              onChange={(e) => handleInputChange('workInfo', 'education', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Universitas"
              value={formData.workInfo.education_group}
              onChange={(e) => handleInputChange('workInfo', 'education_group', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Jurusan"
              value={formData.workInfo.university}
              onChange={(e) => handleInputChange('workInfo', 'university', e.target.value)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderAddressForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }} className="animate-slide-up">
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: 'warning.main' }}><LocationIcon /></Avatar>}
        title="Alamat"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Alamat Lengkap"
              multiline
              rows={2}
              value={formData.address.street}
              onChange={(e) => handleInputChange('address', 'street', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kecamatan"
              value={formData.address.subdistrict}
              onChange={(e) => handleInputChange('address', 'subdistrict', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="RT"
              value={formData.address.rt}
              onChange={(e) => handleInputChange('address', 'rt', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="RW"
              value={formData.address.rw}
              onChange={(e) => handleInputChange('address', 'rw', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kota"
              value={formData.address.city}
              onChange={(e) => handleInputChange('address', 'city', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Provinsi"
              value={formData.address.province}
              onChange={(e) => handleInputChange('address', 'province', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Negara"
              value={formData.address.country}
              onChange={(e) => handleInputChange('address', 'country', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kode Pos"
              value={formData.address.postal_code}
              onChange={(e) => handleInputChange('address', 'postal_code', e.target.value)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderBenefitContactForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }} className="animate-slide-up">
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: 'error.main' }}><BankIcon /></Avatar>}
        title="Benefit & Kontak"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Benefit</Typography>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="BPJS Ketenagakerjaan No"
              value={formData.benefit.lbpjs_ketenagakerjaan_no}
              onChange={(e) => handleInputChange('benefit', 'lbpjs_ketenagakerjaan_no', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="BPJS Kesehatan No"
              value={formData.benefit.lbpjs_kesehatan_no}
              onChange={(e) => handleInputChange('benefit', 'lbpjs_kesehatan_no', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="BPJS Pensiun No"
              value={formData.benefit.lbpjs_pensiun_no}
              onChange={(e) => handleInputChange('benefit', 'lbpjs_pensiun_no', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Company Insurance No"
              value={formData.benefit.company_insurance_no}
              onChange={(e) => handleInputChange('benefit', 'company_insurance_no', e.target.value)}
            />
          </Grid>
        </Grid>
        
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Kontak</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Mobile Phone"
              value={formData.contact.mobile_phone}
              onChange={(e) => handleInputChange('contact', 'mobile_phone', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Alt Mobile Phone"
              value={formData.contact.alt_mobile_phone}
              onChange={(e) => handleInputChange('contact', 'alt_mobile_phone', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Previous Email"
              type="email"
              value={formData.contact.previous_email}
              onChange={(e) => handleInputChange('contact', 'previous_email', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Corporate Email"
              type="email"
              value={formData.contact.corporate_email}
              onChange={(e) => handleInputChange('contact', 'corporate_email', e.target.value)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderTaxOthersForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }} className="animate-slide-up">
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: 'grey.600' }}><SecurityIcon /></Avatar>}
        title="Tax & Others"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Tax</Typography>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tax Category"
              value={formData.tax.tax_category}
              onChange={(e) => handleInputChange('tax', 'tax_category', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tax ID"
              value={formData.tax.tax_id}
              onChange={(e) => handleInputChange('tax', 'tax_id', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Payroll Seniority"
              type="date"
              value={formData.tax.payroll_seniority}
              onChange={(e) => handleInputChange('tax', 'payroll_seniority', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Salary Scale Date"
              type="date"
              value={formData.tax.salary_scale_date}
              onChange={(e) => handleInputChange('tax', 'salary_scale_date', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Others</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Office Type</InputLabel>
              <Select
                value={formData.others.office_type}
                onChange={(e) => handleInputChange('others', 'office_type', e.target.value)}
              >
                <MenuItem value="Pusat">Pusat</MenuItem>
                <MenuItem value="Cabang">Cabang</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Toll Fee"
              type="number"
              value={formData.others.toll_fee}
              onChange={(e) => handleInputChange('others', 'toll_fee', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Distance KM"
              value={formData.others.distance_km}
              onChange={(e) => handleInputChange('others', 'distance_km', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Penjamin"
              value={formData.others.penjamin}
              onChange={(e) => handleInputChange('others', 'penjamin', e.target.value)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return renderPersonalDataForm();
      case 1:
        return renderWorkInfoForm();
      case 2:
        return renderAddressForm();
      case 3:
        return renderBenefitContactForm();
      case 4:
        return renderTaxOthersForm();
      default:
        return null;
    }
  };

  return (
    <Box sx={{ p: 2 }} className="animate-fade-in">
      {/* Header */}
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton 
          onClick={() => navigate('/kontak/employee')}
          sx={{ 
            bgcolor: 'grey.100',
            '&:hover': { bgcolor: 'grey.200' }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Tambah Karyawan Baru (Static)
        </Typography>
      </Box>

      {/* Stepper */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>

      {/* Form Content */}
      <Box sx={{ mb: 3 }}>
        {renderStepContent(activeStep)}
      </Box>

      {/* Navigation Buttons */}
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            variant="outlined"
            size="large"
          >
            Kembali
          </Button>
          <Box sx={{ display: 'flex', gap: 2 }}>
            {activeStep === steps.length - 1 ? (
              <Button
                variant="contained"
                onClick={handleSave}
                startIcon={<SaveIcon />}
                size="large"
                sx={{ 
                  px: 4,
                  py: 1.5,
                  fontWeight: 600
                }}
              >
                Simpan Karyawan
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleNext}
                size="large"
                sx={{ 
                  px: 4,
                  py: 1.5,
                  fontWeight: 600
                }}
              >
                Selanjutnya
              </Button>
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AddEmployeeStatic;

